import {
  all, call, fork, put, takeLatest,
} from 'redux-saga/effects';
import { AppActions } from '../actions/action-types';
import { fetchTranslationsApi } from '../apis';
import { updateTranslations } from '../reducers/translations-reducer';
import { updateRedirectUrlData } from '../reducers/redirect-reducer';
import { updateClientMetaData } from '../reducers/client-metadata-reducer';
import LOCALES from '../../constants/locales';
import { getSuccessLoginRedirectUrl } from '../../utils/success-login-redirect-url-util';

function* fetchTranslations({ payload }) {
  const { response } = yield call(fetchTranslationsApi, payload);
  const { status, data } = response;

  if (status) {
    yield put(updateTranslations(data));
  }
}

function* fetchRedirectUrlData({ payload }) {
  yield put(updateRedirectUrlData(payload));
}

function* fetchClientMetaData({ payload }) {
  yield put(updateClientMetaData(payload));
}

function* fetchAppMountedData() {
  yield fork(fetchTranslations, { payload: LOCALES.EN_US });
  const queryParameters = new URLSearchParams(window.location.search);
  const redirectUrl = queryParameters.get('redirectUrl') ? queryParameters.get('redirectUrl') : getSuccessLoginRedirectUrl();
  const metadata = queryParameters.get('metadata');
  if (redirectUrl !== null) {
    yield fork(fetchRedirectUrlData, { payload: redirectUrl });
  }
  if (metadata !== null) {
    yield fork(fetchClientMetaData, { payload: metadata });
  }
}

function* appMountedAction() {
  yield takeLatest(AppActions.APP_MOUNTED, fetchAppMountedData);
}

function* fetchTranslationsAction() {
  yield takeLatest(AppActions.FETCH_TRANSLATIONS, fetchTranslations);
}

function* fetchRedirectUrlAction() {
  yield takeLatest(AppActions.APP_REDIRECT_URL, fetchRedirectUrlData);
}

function* fetchClientMetaDataAction() {
  yield takeLatest(AppActions.FETCH_CLIENT_METADATA, fetchClientMetaData);
}

export default function* root() {
  yield all(
    [fork(appMountedAction),
      fork(fetchTranslationsAction),
      fork(fetchRedirectUrlAction),
      fork(fetchClientMetaDataAction),
    ],
  );
}
